import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

const usePresentationActions = () => {
    const navigate = useNavigate()

    const navigateToPage = useCallback((path, state) => {
        navigate(path, state ? { state } : undefined)
    }, [navigate])

    return { navigateToPage }
}

export default usePresentationActions
